import { createModalStoreFactory } from '@/features/_shared/stores/create-modal.store';
import { useShallow } from 'zustand/shallow';
import type {
  ICreateLabelCustomerModalProps,
  TCreateLabelCustomerModalType,
} from '@/features/customers/label-customer/components/modals/create-label-customer-modal/create-label-customer-modal';
import type {
  IDeleteLabelCustomerModalProps,
  TDeleteLabelCustomerModalType,
} from '@/features/customers/label-customer/components/modals/delete-label-customer-modal/delete-label-customer-modal';
import type {
  IUpdateLabelCustomerModalProps,
  TUpdateLabelCustomerModalType,
} from '@/features/customers/label-customer/components/modals/update-label-customer-modal/update-label-customer-modal';
import type {
  IUpdateDetailCustomerModalProps,
  TUpdateDetailCustomerModalType,
} from '@/features/customers/customer/components/modals/update-detail-customer-modal';
import type {
  IAssignLabelCustomerModalProps,
  TAssignLabelCustomerModalType,
} from '@/features/customers/label-customer/components/modals/assign-label-customer-modal';
import {
  ICSATPreviewModalProps,
  TCSATPreviewModalType,
} from '@/features/customers/customer-survey/components/modals/csat-preview-modal/csat-preview-modal';
import {
  IDeleteQuestionListModalProps,
  TDeleteQuestionListModalType,
} from '@/features/customers/customer-survey/components/modals/delete-question-list/delete-question-list';

import type {
  ICSATResponseDetailModalProps,
  TCSATResponseDetailModalType,
} from '@/features/customers/customer-survey/components/modals/csat-response-detail-modal/csat-response-detail-modal';

// --------- Label Customer Modal Root Types ---------
export type TLabelCustomerModalRootTypes =
  | TCreateLabelCustomerModalType
  | TUpdateLabelCustomerModalType
  | TDeleteLabelCustomerModalType
  | TAssignLabelCustomerModalType;

// --------- Customer Detail Modal Root Types ---------
export type TCustomerDetailModalRootTypes = TUpdateDetailCustomerModalType;

// --------- Customer Modal Root Types ---------
export type TCustomerModuleModalRootTypes =
  | TLabelCustomerModalRootTypes
  | TCustomerDetailModalRootTypes
  | TCSATPreviewModalType
  | TDeleteQuestionListModalType
  | TCSATResponseDetailModalType;

// --------- Customer Modal Root Props ---------
type TCustomerModuleModalRootProps = {
  // Label Customer Modal
  CreateLabelCustomerModal: ICreateLabelCustomerModalProps;
  UpdateLabelCustomerModal: IUpdateLabelCustomerModalProps;
  DeleteLabelCustomerModal: IDeleteLabelCustomerModalProps;
  AssignLabelCustomerModal: IAssignLabelCustomerModalProps;
  // Customer Detail Modal
  UpdateDetailCustomerModal: IUpdateDetailCustomerModalProps;
  // CSAT Preview Modal
  CSATPreviewModal: ICSATPreviewModalProps;
  DeleteQuestionListModal: IDeleteQuestionListModalProps;
  CSATResponseDetailModal: ICSATResponseDetailModalProps;
};

export const useCustomerModuleModalRootStore = createModalStoreFactory<
  TCustomerModuleModalRootTypes,
  TCustomerModuleModalRootProps
>();

export const useCustomerModuleModalRootActionsStore = () =>
  useCustomerModuleModalRootStore(useShallow((state) => state.actions));
